export default __webpack_public_path__ + "static/media/baixarvenda3.42e830f5.png";